import React, { Component } from 'react';
import SearchRubricaView from 'uniba-volto-persone/components/Blocks/SearchRubrica/View';
import { searchContent } from '@plone/volto/actions';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

const data = {
    "@type": "searchRubrica",
};

class HomeView extends Component {
    /**
      * Property types.
      * @property {Object} propTypes Property types.
      * @static
      */
    static propTypes = {
        searchContent: PropTypes.func.isRequired,
        path: PropTypes.arrayOf(
            PropTypes.shape({
                '@id': PropTypes.string,
                title: PropTypes.string,
                description: PropTypes.string,
            }),
        ),
        content: PropTypes.shape({
            '@id': PropTypes.string,
            title: PropTypes.string,
            description: PropTypes.string,
        }),
    };

    /**
 * Default properties.
 * @property {Object} defaultProps Default properties.
 * @static
 */
    static defaultProps = {
        path: [],
        content: null,
    };

    componentDidMount() {
        this.props.searchContent(
            '/rubrica',
            {
                portal_type: ['Folder'],
                review_state: 'published',
            },
            'FolderRubrica'
        );

        this.contentArea = document.querySelector('.ui.basic.segment.content-area');
        this.bricioleSection = document.getElementById('briciole');

        if (this.contentArea) {
            this.originalPadding = this.contentArea.style.padding;
            this.originalMarginTop = this.contentArea.style.marginTop;
            this.contentArea.style.padding = '0';
            this.contentArea.style.marginTop = '0';
        }

        if (this.bricioleSection) {
            this.originalDisplay = this.bricioleSection.style.display;
            this.bricioleSection.style.display = 'none';
        }
    }

    componentWillUnmount() {
        if (this.contentArea) {
            this.contentArea.style.padding = this.originalPadding || '';
            this.contentArea.style.marginTop = this.originalMarginTop || '';
        }

        if (this.bricioleSection) {
            this.bricioleSection.style.display = this.originalDisplay || '';
        }
    }

    /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
    render() {
        if (!this.props.path || this.props.path.length === 0 || !this.props.path[0]) {
            return null;
        }
        data['path'] = this.props.path[0];
        return (
            <div id="page-document" className="ui container px-4 p-0">
                <SearchRubricaView data={data} id="HomePageSearchRubrica" />
            </div>
        );
    }
}

export default connect(
    state => ({
        path: state.search.subrequests.FolderRubrica?.items,
    }),
    dispatch => bindActionCreators({ searchContent }, dispatch),
)(HomeView);